import { Component, Input } from "@angular/core";
import { List } from "immutable";

@Component({
    selector: 'fak-tros-chart',
    templateUrl: './fak-tros-chart.component.html'
})
export class FakTrosChartComponent {
    @Input() dataSource: List<List<any>> = List([List([])]);
}